<div class="td-cnt-ext">
    <div class="td-cnt">
        <app-costing-tool style="width: 100%;" [inputEnquiryNo]="enquiryNo" [inpuItem]="item" [inputOrigin]="origin"
            [inputUseNearestMatch]="useNearestMatch"
            [inputCostsSourceCostingToolRecordId]="costsSourceCostingToolRecordId"
            [inputCostsSourceCostingToolVersionId]="costsSourceCostingToolVersionId"
            [inputUnitSystem]="unitSystem"
            [inputCurrency]="currency"
            (onBackClick)="onCloseCostingTool()"></app-costing-tool>
    </div>
</div>
